var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12213_93610)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 74.8747C41.6693 74.9582 40.8349 75 40 75C33.3696 75 27.0107 72.3661 22.3223 67.6777C17.6339 62.9893 15 56.6304 15 50C15 43.3696 17.6339 37.0107 22.3223 32.3223C27.0107 27.6339 33.3696 25 40 25C40.8349 25 41.6693 25.0418 42.5 25.1253V32.6253C41.6707 32.5239 40.8353 32.482 40 32.5C35.3587 32.5 30.9075 34.3437 27.6256 37.6256C24.3437 40.9075 22.5 45.3587 22.5 50C22.5 54.6413 24.3437 59.0925 27.6256 62.3744C30.9075 65.6563 35.3587 67.5 40 67.5C40.8353 67.518 41.6707 67.4761 42.5 67.3747V74.8747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 74.8747C84.1693 74.9582 83.3349 75 82.5 75C75.8696 75 69.5107 72.3661 64.8223 67.6777C60.1339 62.9893 57.5 56.6304 57.5 50C57.5 43.3696 60.1339 37.0107 64.8223 32.3223C69.5107 27.6339 75.8696 25 82.5 25C83.3349 25 84.1693 25.0418 85 25.1253V32.6253C84.1707 32.5239 83.3353 32.482 82.5 32.5C78.5099 32.4997 74.6396 33.8629 71.5304 36.3637C68.4213 38.8644 66.2601 42.3526 65.4051 46.25H80V53.75H65.4051C66.2601 57.6474 68.4213 61.1356 71.5304 63.6363C74.6396 66.1371 78.5099 67.5003 82.5 67.5C83.3353 67.518 84.1707 67.4761 85 67.3747V74.8747Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12213_93610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    fill: "white",
    transform: "translate(15 25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCe);
export default __webpack_public_path__ + "static/media/ic-ce.b71eb02fe883a858ecca64794b9cdc37.svg";
export { ForwardRef as ReactComponent };